export type EditorFormProps = {
  testIdPrefix: string;
  children: React.ReactNode;
  containerCss?: string;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
};

export const EditorForm = ({
  testIdPrefix,
  children,
  containerCss,
  onSubmit,
}: EditorFormProps): React.ReactElement => {
  return (
    <form
      data-testid={`${testIdPrefix}-form`}
      onSubmit={onSubmit}
      css={`
        min-width: 0;
        flex: 1 1 auto;
        height: 100%;
        isolation: isolate;
        display: flex;
        flex-flow: column nowrap;
        ${containerCss || ''}
      `}
    >
      {children}
    </form>
  );
};
